@if ((selectedConfiguratorType$ | async) !== 'external_blind') {
  <icc-select-box
    [title]="'ROLLER_SHUTTER_LEGACY|Typ pancerza:' | translate"
    [description]="(profile$ | async)?.name"
    [imageUrl]="'/files/profile/' + ((profile$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="changeProfile()"
  ></icc-select-box>
}
<div class="box-form mat-elevation-z3">
  <form>
    @if (availableRoundReel && ((selectedConfiguratorType$ | async) !== 'external_blind')) {
      <mat-form-field>
        <mat-label>{{ 'ROLLER_SHUTTER_LEGACY|Rura nawojowa:' | translate }}</mat-label>
        <mat-select  name="roundReel" [value]="roundReel$ | async" (selectionChange)="changeRoundReel($event.value)">
          @for (reel of roundReels; track reel) {
            <mat-option [value]="reel.id">{{ reel.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    <mat-form-field>
      <mat-label>{{ 'ROLLER_SHUTTER_LEGACY|Zmień wysokość skrzynki:' | translate }}</mat-label>
      <mat-select  name="roundReel" [value]="boxHeight$ | async" (selectionChange)="onBoxHeightChange($event.value)">
        @for (size of boxSizes; track size) {
          <mat-option [value]="size">{{ size | unitmm:0:0 }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </form>
</div>
<div class="box-form mat-elevation-z3">
  <h4>{{ 'ROLLER_SHUTTER_LEGACY|Zmiana prowadnic i listwy końcowej:' | translate }}</h4>
  <div id="shutter-layout-draw" #parent>
    <icc-draw [details]="drawService.details" [options]="drawOptions" fitTo="width" iccDrawResize [drawWidth]="width$ | async" [drawHeight]="height$ | async" [parentElement]="parent"></icc-draw>
  </div>
</div>
